<template>
    <section id="splash">

        <div class="bgs">

            <transition-group name="fade">
                <div class="bg" 
                    v-for="(image, key) in images" 
                    :key="image" 
                    v-if="activeImage == key"
                    :style="{
                        backgroundImage: 'url(' + image + ')', 
                        backgroundPosition: positions[key]
                    }">
                </div>
            </transition-group>
           

        </div>
        <div id="splash-anchor" class="scroll-to-anchor"></div>
            
        <div class="overlay"></div>

        <div class="container">
            <div class="tekst">
                Gradnja zelene prihodnosti
            </div>
        </div>        
    </section>
</template>

<script>
export default {
  data() {
    return {
      images: [
        "/static/splash/1.jpg",
        "/static/splash/2.jpg",
        "/static/splash/3.jpg"
      ],
      positions: ["50% 0%", "50% 50%", "50% 50%"],
      activeImage: 0
    };
  },
  methods: {},
  created() {
    var interval = 4500;
    var imagesCount = this.images.length;

    setInterval(() => {
      if (this.activeImage == imagesCount - 1) {
        this.activeImage = 0;
        return;
      }
      this.activeImage++;
    }, interval);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Splash.vue